import { getType } from "typesafe-actions";
import actions, { InvoiceActions } from "./actions";
import { IInvoiceTableProperties, InvoiceTableProperties } from '../../../../Shared/React/typings/api-models/invoice/InvoiceTable';

export interface IInvoicePageState {
    residentialStandardInvoices: IInvoiceTableProperties,
    residentialDuplicateInvoices: IInvoiceTableProperties,
    residentialMismatchInvoices: IInvoiceTableProperties,
    communityStandardInvoices: IInvoiceTableProperties,
    communityDuplicateInvoices: IInvoiceTableProperties,
    communityMismatchInvoices: IInvoiceTableProperties,
    pendingStandardCharges: IInvoiceTableProperties,
    pendingDuplicateCharges: IInvoiceTableProperties,
    pendingMismatchCharges: IInvoiceTableProperties,
    commercialSingleInvoices: IInvoiceTableProperties,
    commercialMultipleInvoices: IInvoiceTableProperties,
    commercialSingleSelectInvoices: IInvoiceTableProperties,
    commercialSentSingleInvoices: IInvoiceTableProperties,
    loading: boolean,
    previewResponse: any,
    showPreview: boolean,
    showApproveUpload: boolean,
    approveModalInvoiceGroupingId: number,
    fetchNewData: boolean,
    showPreviewDisabledModal: boolean,
    currentTable: IInvoiceTableProperties,
    loaded: boolean,
    downloadingInvoice: boolean,
}

export const InvoicePageInitialState =
{
    residentialStandardInvoices: new InvoiceTableProperties(),
    residentialDuplicateInvoices: new InvoiceTableProperties(),
    residentialMismatchInvoices: new InvoiceTableProperties(),
    communityStandardInvoices: new InvoiceTableProperties(),
    communityDuplicateInvoices: new InvoiceTableProperties(),
    communityMismatchInvoices: new InvoiceTableProperties(),
    pendingStandardCharges: new InvoiceTableProperties(),
    pendingDuplicateCharges: new InvoiceTableProperties(),
    pendingMismatchCharges: new InvoiceTableProperties(),
    commercialSingleInvoices: new InvoiceTableProperties(),
    commercialMultipleInvoices: new InvoiceTableProperties(),
    commercialSingleSelectInvoices: new InvoiceTableProperties(),
    commercialSentSingleInvoices: new InvoiceTableProperties(),
    loading: false,
    previewResponse: null,
    showPreview: false,
    showApproveUpload: false,
    approveModalInvoiceGroupingId: null,
    fetchNewData: false,
    currentTable: null,
    showPreviewDisabledModal: false,
    loaded: false,
    downloadingInvoice: false,
}

const initialState = InvoicePageInitialState;

export const invoiceReducer = (state: IInvoicePageState = initialState, action: InvoiceActions): IInvoicePageState => {
    switch (action.type) {
        case getType(actions.removeInvoice.request):
            return {
                ...state,
                loading: true,
                fetchNewData: false
            };
        case getType(actions.removeInvoice.success):
            return {
                ...state,
                loading: false,
                fetchNewData: true
            };
        case getType(actions.previewInvoice.request):
            return {
                ...state,
                loading: true,
                fetchNewData: false,
                downloadingInvoice: false
            };
        case getType(actions.previewInvoice.success):
            return {
                ...state,
                loading: false,
                previewResponse: action.payload,
                showPreview: false,
                fetchNewData: false
            };
        case getType(actions.approveSelected.request):
            return {
                ...state,
                loading: true,
                fetchNewData: false,
                downloadingInvoice: false
            };
        case getType(actions.approveSelected.success):
            return {
                ...state,
                loading: false,
                fetchNewData: true,
                downloadingInvoice: false
            };
        case getType(actions.approveSelected.failure):
            return {
                ...state,
                loading: false,
                fetchNewData: false,
                downloadingInvoice: false
            };
        case getType(actions.ignoreSelected.request):
            return {
                ...state,
                loading: true,
                fetchNewData: false,
                downloadingInvoice: false
            };
        case getType(actions.ignoreSelected.success):
            return {
                ...state,
                loading: false,
                fetchNewData: true,
                downloadingInvoice: false
            };
        case getType(actions.ignoreSelected.failure):
            return {
                ...state,
                loading: false,
                fetchNewData: false,
                downloadingInvoice: false
            };
        case getType(actions.holdSelected.request):
            return {
                ...state,
                loading: true,
                fetchNewData: false,
                downloadingInvoice: false
            };
        case getType(actions.holdSelected.success):
            return {
                ...state,
                loading: false,
                fetchNewData: true,
                downloadingInvoice: false
            };
        case getType(actions.holdSelected.failure):
            return {
                ...state,
                loading: false,
                fetchNewData: false,
                downloadingInvoice: false
            };
        case getType(actions.getInvoices.request):
            return {
                ...state,
                loading: true,
                fetchNewData: false,
                downloadingInvoice: false
            }
        case getType(actions.approveStandardInvoices.request):
            return {
                ...state,
                loading: true,
                fetchNewData: false,
                downloadingInvoice: false
            };
        case getType(actions.approveStandardInvoices.success):
            return {
                ...state,
                loading: false,
                fetchNewData: true,
                downloadingInvoice: false
            };
        case getType(actions.approveStandardInvoices.failure):
            return {
                ...state,
                loading: false,
                fetchNewData: false,
                downloadingInvoice: false
            };
          case getType(actions.approveBatch.request):
            return {
                ...state,
                loading: true,
                fetchNewData: false,
                downloadingInvoice: false
            };
          case getType(actions.approveBatch.success):
              return {
                  ...state,
                  loading: false,
                  fetchNewData: true,
                  downloadingInvoice: false
              };
          case getType(actions.approveBatch.failure):
              return {
                  ...state,
                  loading: false,
                  fetchNewData: false,
                  downloadingInvoice: false
              };
        case getType(actions.clearPreview):
            return {
                ...state,
                previewResponse: null,
                showPreview: false,
                fetchNewData: false,
                downloadingInvoice: false
            }
        case getType(actions.fetchingNewData):
            return {
                ...state,
                loading: true,
                fetchNewData: false,
                downloadingInvoice: false
            }
        case getType(actions.completedFetchingNewData):
            return {
                ...state,
                loading: false,
                fetchNewData: false,
                downloadingInvoice: false
            }
        case getType(actions.approveInvoiceWithUpload.request):
            return {
                ...state,
                loading: true,
                fetchNewData: false,
                downloadingInvoice: false
            };
        case getType(actions.approveInvoiceWithUpload.success):
            return {
                ...state,
                loading: false,
                fetchNewData: true,
                downloadingInvoice: false
            };
        case getType(actions.approveInvoiceWithUpload.failure):
            return {
                ...state,
                loading: false,
                fetchNewData: true,
                downloadingInvoice: false
            };
        case getType(actions.getInvoicePdfData.request):
            return {
                ...state,
                loading: true,
                fetchNewData: false,
                previewResponse: null,
                loaded: false,
                downloadingInvoice: false
            };
        case getType(actions.getInvoicePdfData.success):
            if (action.payload === "File too large") {
                return {
                    ...state,
                    loaded: true,
                    fetchNewData: false,
                    showPreviewDisabledModal: true,
                    downloadingInvoice: false
                }
            }
            return {
                ...state,
                loading: false,
                previewResponse: "data:application/pdf;base64," + action.payload,
                fetchNewData: false,
                loaded: true,
                downloadingInvoice: false
            };
        case getType(actions.getInvoicePdfData.failure):
            return {
                ...state,
                loading: false,
                fetchNewData: false,
                loaded: false,
                downloadingInvoice: false
            };
        case getType(actions.openInvoiceTab.request):
            return {
                ...state,
                loading: true,
                fetchNewData: false,
                previewResponse: null,
                loaded: false,
                downloadingInvoice: false
            };
        case getType(actions.openInvoiceTab.success):
            return {
                ...state,
                loading: false,
                previewResponse: null,
                fetchNewData: false,
                loaded: true,
                downloadingInvoice: true
            };
        case getType(actions.openInvoiceTab.failure):
            return {
                ...state,
                loading: false,
                fetchNewData: false,
                loaded: false,
                downloadingInvoice: false
            };
        case getType(actions.closePreviewDisabledModal):
            return {
                ...state,
                fetchNewData: false,
                loaded: true,
                downloadingInvoice: false,
                showPreviewDisabledModal: false
            };
        default:
            return {
                ...state,
                loading: false
            };
    }
};
